// Modules
import { Link, useOutlet } from "react-router-dom";
import { useAccountManagementPage } from "containers/AccountManagement/useAccountManagementPage";

// Components
import { Button as ANTButton, Input } from "antd";
import getIcon, { IconProps } from "utils/getIcon";
import ExpandedRowTable from "components/atoms/ExpandedRowTable/ExpandedRowTable";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import { Head } from "components/molecules/Head/Head";
import CollapsibleTable from "components/atoms/CollapsibleTable/CollapsibleTable";

// styles
import styles from "containers/AccountManagement/accountManagementComponent.module.css";

// Constants
import { Routes, AccountManagement as Constants, PageTitles } from "constants/global";
import { ACCOUNT_MANAGEMENT_COLUMN_DATA } from "constants/accountManagementData";

const Icon = (props: IconProps) => getIcon({ ...props });

const AccountManagementPage = () => {
	const childRouteElement = useOutlet();
	const componentProps = useAccountManagementPage();

	const { defaultGroupKey, getGroupHeader, generateCols, handleSearchTenantCode, handleKeyDown, handleUserSearch, updateEnterKeyEvent, groupList, searchTenantCode, searchUser } =
		componentProps;

	return (
		<div>
			<Head>{PageTitles.ACCOUNT_MANAGEMENT}</Head>
			{!childRouteElement && (
				<div className="relative">
					<div className={styles?.root}>
						<PageTitle showBackIcon={false} title={Constants.ROLE_HEADER} subTitle={Constants.ROLE_SUB_HEADER} />

						<div className={styles?.btn_wrapper}>
							<ANTButton className={styles?.btn2} type="primary">
								<Link to={Routes?.CREATE_ACCOUNT}>{Constants.CREATE_ACCOUNT_LABEL}</Link>
							</ANTButton>
						</div>

						<div className={styles?.txt}>{Constants.SEARCH_BY}</div>

						<div className={styles?.search_wrapper}>
							<Input
								placeholder={Constants.USERNAME_PLACEHOLDER}
								value={searchUser}
								onChange={handleUserSearch}
								onKeyDown={(event: any) => {
									if (event.key === "Enter") {
										updateEnterKeyEvent();
									}
								}}
								className={styles?.searchUserInput}
								suffix={
									<Icon
										height="24px"
										width="24px"
										icon="search"
										onClickHandler={() => {
											updateEnterKeyEvent();
										}}
									/>
								}
							/>
							<div className={styles?.ortxt}>or</div>
							<Input
								placeholder={Constants.TENANT_CODE_PLACEHOLDER}
								value={searchTenantCode}
								onChange={handleSearchTenantCode}
								onKeyDown={handleKeyDown}
								className={styles?.searchGroupInput}
								suffix={
									<Icon
										height="24px"
										width="24px"
										icon="search"
										onClickHandler={() => {
											updateEnterKeyEvent();
										}}
									/>
								}
							/>
						</div>
					</div>
					{groupList &&
						groupList?.map((groupItem, index) => {
							return (
								<div className={styles.table_container} key={groupItem.group_code}>
									<CollapsibleTable
										keyIndex={index}
										defaultExpandedGroupKey={defaultGroupKey}
										key={groupItem.group_id}
										rowClassName="collapsible-table"
										showHeader={false}
										generateCols={generateCols}
										groupItem={[groupItem]}
										generateData={getGroupHeader}
										expandedRowElement={() => (
											<ExpandedRowTable
												searchUser={searchUser}
												searchTenantCode={searchTenantCode}
												columnHeaderData={ACCOUNT_MANAGEMENT_COLUMN_DATA}
												groupDetails={groupItem}
												rowsPerPage={Constants.DEFAULT_ROW_PER_PAGE}
											/>
										)}
									/>
								</div>
							);
						})}
				</div>
			)}
			{childRouteElement}
		</div>
	);
};

export default AccountManagementPage;
